var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { attrs: { id: "personal-detail" } }, [
    _c(
      "form",
      {
        on: {
          submit: function($event) {
            $event.preventDefault()
          }
        }
      },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-lg-6 offset-lg-3 col-12 p-0" }, [
            _c("div", { staticClass: "card shadow-sm" }, [
              _c("div", { staticClass: "card-body" }, [
                _c("p", { staticClass: "h5" }, [_vm._v("ข้อมูลส่วนตัว")]),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("div", { staticClass: "form" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _vm._m(0),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.productCode,
                              expression: "productCode"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", id: "product-code" },
                          domProps: { value: _vm.productCode },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.productCode = $event.target.value
                            }
                          }
                        })
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("div", { staticClass: "form" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _vm._m(1),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.branchCode,
                              expression: "branchCode"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", id: "branch-code" },
                          domProps: { value: _vm.branchCode },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.branchCode = $event.target.value
                            }
                          }
                        })
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("div", { staticClass: "form" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _vm._m(2),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.partnerRefNo,
                              expression: "partnerRefNo"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", id: "partner-ref-no" },
                          domProps: { value: _vm.partnerRefNo },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.partnerRefNo = $event.target.value
                            }
                          }
                        })
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("div", { staticClass: "form" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _vm._m(3),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.prenameThai,
                                expression: "prenameThai"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: { id: "prename-thai" },
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.prenameThai = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              }
                            }
                          },
                          _vm._l(["นาย", "นาง", "นางสาว", "อื่นๆ"], function(
                            item
                          ) {
                            return _c(
                              "option",
                              { key: item, domProps: { value: item } },
                              [_vm._v(" " + _vm._s(item))]
                            )
                          }),
                          0
                        )
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("div", { staticClass: "form" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "prename-eng" } }, [
                          _vm._v("คำนำหน้าชื่อ (อังกฤษ) ")
                        ]),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.prenameEng,
                                expression: "prenameEng"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: { id: "prename-eng" },
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.prenameEng = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              }
                            }
                          },
                          _vm._l(["Mr.", "Mrs.", "Ms.", "Other"], function(
                            item
                          ) {
                            return _c(
                              "option",
                              { key: item, domProps: { value: item } },
                              [_vm._v(" " + _vm._s(item))]
                            )
                          }),
                          0
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("div", { staticClass: "form" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _vm._m(4),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.thaiName,
                              expression: "thaiName"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", id: "thai-name" },
                          domProps: { value: _vm.thaiName },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.thaiName = $event.target.value
                            }
                          }
                        })
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("div", { staticClass: "form" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _vm._m(5),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.engName,
                              expression: "engName"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", id: "eng-name" },
                          domProps: { value: _vm.engName },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.engName = $event.target.value
                            }
                          }
                        })
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("div", { staticClass: "form" }, [
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c("label", { attrs: { for: "birthday" } }, [
                            _vm._v("วันเกิด ")
                          ]),
                          _vm._v(" "),
                          _c("b-form-datepicker", {
                            staticClass: "mb-2",
                            attrs: {
                              id: "birthday",
                              locale: "th",
                              placeholder: "DD-MM-YYYY",
                              "date-format-options": {
                                year: "numeric",
                                month: "numeric",
                                day: "numeric"
                              }
                            },
                            model: {
                              value: _vm.birthday,
                              callback: function($$v) {
                                _vm.birthday = $$v
                              },
                              expression: "birthday"
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("div", { staticClass: "form" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "age" } }, [
                          _vm._v("อายุ")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.age,
                              expression: "age"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", id: "age" },
                          domProps: { value: _vm.age },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.age = $event.target.value
                            }
                          }
                        })
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("div", { staticClass: "form" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _vm._m(6),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.nationality,
                              expression: "nationality"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", id: "nationality" },
                          domProps: { value: _vm.nationality },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.nationality = $event.target.value
                            }
                          }
                        })
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("div", { staticClass: "form" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _vm._m(7),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.idcard,
                              expression: "idcard"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", id: "idcard" },
                          domProps: { value: _vm.idcard },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.idcard = $event.target.value
                            }
                          }
                        })
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("div", { staticClass: "form" }, [
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _vm._m(8),
                          _vm._v(" "),
                          _c("b-form-datepicker", {
                            staticClass: "mb-2",
                            attrs: {
                              id: "idcard-expire-date",
                              locale: "th",
                              placeholder: "DD-MM-YYYY",
                              "date-format-options": {
                                year: "numeric",
                                month: "numeric",
                                day: "numeric"
                              }
                            },
                            model: {
                              value: _vm.idcardExpireDate,
                              callback: function($$v) {
                                _vm.idcardExpireDate = $$v
                              },
                              expression: "idcardExpireDate"
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("div", { staticClass: "form" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "marriage-status" } }, [
                          _vm._v("สถานภาพ")
                        ]),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.marriageStatus,
                                expression: "marriageStatus"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: { id: "marriage-status" },
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.marriageStatus = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              }
                            }
                          },
                          _vm._l(["โสด", "สมรส", "หย่า"], function(item) {
                            return _c(
                              "option",
                              { key: item, domProps: { value: item } },
                              [_vm._v(" " + _vm._s(item))]
                            )
                          }),
                          0
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("div", { staticClass: "form" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "living-status" } }, [
                          _vm._v("สถานะของการอยู่อาศัย")
                        ]),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.livingStatus,
                                expression: "livingStatus"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: { id: "living-status" },
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.livingStatus = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              }
                            }
                          },
                          _vm._l(
                            [
                              "บ้านตนเองปลอดภาระ",
                              "บ้านตนเองกำลังผ่อน",
                              "บิดาร/มารดา",
                              "บ้านญาติ/พี่น้อง/บุคคลอื่น",
                              "สวัสดิการ",
                              "เช่าอยู่"
                            ],
                            function(item) {
                              return _c(
                                "option",
                                { key: item, domProps: { value: item } },
                                [_vm._v(" " + _vm._s(item))]
                              )
                            }
                          ),
                          0
                        )
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("div", { staticClass: "form" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "current-building" } }, [
                          _vm._v("ชื่อหมู่บ้าน/อาคารชุด")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.currentBuilding,
                              expression: "currentBuilding"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", id: "current-building" },
                          domProps: { value: _vm.currentBuilding },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.currentBuilding = $event.target.value
                            }
                          }
                        })
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("div", { staticClass: "form" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "current-room-no" } }, [
                          _vm._v("เลขที่ห้องชั้น")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.currentRoomNo,
                              expression: "currentRoomNo"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", id: "current-room-no" },
                          domProps: { value: _vm.currentRoomNo },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.currentRoomNo = $event.target.value
                            }
                          }
                        })
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("div", { staticClass: "form" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c(
                          "label",
                          { attrs: { for: "current-address-modal" } },
                          [_vm._v("บ้านเลขที่")]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.currentAddressModal,
                              expression: "currentAddressModal"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", id: "current-address-modal" },
                          domProps: { value: _vm.currentAddressModal },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.currentAddressModal = $event.target.value
                            }
                          }
                        })
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("div", { staticClass: "form" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "current-moo" } }, [
                          _vm._v("หมู่")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.currentMoo,
                              expression: "currentMoo"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", id: "current-moo" },
                          domProps: { value: _vm.currentMoo },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.currentMoo = $event.target.value
                            }
                          }
                        })
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("div", { staticClass: "form" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "current-soi" } }, [
                          _vm._v("ซอย")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.currentSoi,
                              expression: "currentSoi"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", id: "current-soi" },
                          domProps: { value: _vm.currentSoi },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.currentSoi = $event.target.value
                            }
                          }
                        })
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("div", { staticClass: "form" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "current-road" } }, [
                          _vm._v("ถนน")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.currentRoad,
                              expression: "currentRoad"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", id: "current-road" },
                          domProps: { value: _vm.currentRoad },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.currentRoad = $event.target.value
                            }
                          }
                        })
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("div", { staticClass: "form" }, [
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c(
                            "label",
                            { attrs: { for: "current-text-address" } },
                            [_vm._v("ที่อยู่")]
                          ),
                          _vm._v(" "),
                          _c("v-select", {
                            attrs: {
                              id: "current-text-address",
                              options: _vm.currentOptionsAddress,
                              label: "texts"
                            },
                            on: {
                              search: function(search) {
                                _vm.fetchAddress(search)
                              }
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "option",
                                fn: function(option) {
                                  return [
                                    _c("span", { class: option.texts }),
                                    _vm._v(
                                      "\n                                          " +
                                        _vm._s(option.texts) +
                                        "\n                                        "
                                    )
                                  ]
                                }
                              }
                            ]),
                            model: {
                              value: _vm.currentTextAddress,
                              callback: function($$v) {
                                _vm.currentTextAddress = $$v
                              },
                              expression: "currentTextAddress"
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("div", { staticClass: "form" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "mobile" } }, [
                          _vm._v("โทรศัพท์มือถือ")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.mobile,
                              expression: "mobile"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", id: "mobile" },
                          domProps: { value: _vm.mobile },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.mobile = $event.target.value
                            }
                          }
                        })
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("div", { staticClass: "form" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "phone" } }, [
                          _vm._v("เบอร์โทรศัพท์(สำรอง)")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.phone,
                              expression: "phone"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", id: "phone" },
                          domProps: { value: _vm.phone },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.phone = $event.target.value
                            }
                          }
                        })
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("div", { staticClass: "form" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "email" } }, [
                          _vm._v("e-mail")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.email,
                              expression: "email"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", id: "email" },
                          domProps: { value: _vm.email },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.email = $event.target.value
                            }
                          }
                        })
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("div", { staticClass: "form" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "lineId" } }, [
                          _vm._v("line")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.lineId,
                              expression: "lineId"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", id: "lineId" },
                          domProps: { value: _vm.lineId },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.lineId = $event.target.value
                            }
                          }
                        })
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("div", { staticClass: "form" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "facebook" } }, [
                          _vm._v("facebook")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.facebook,
                              expression: "facebook"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", id: "facebook" },
                          domProps: { value: _vm.facebook },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.facebook = $event.target.value
                            }
                          }
                        })
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("div", { staticClass: "form" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "documents-receive" } }, [
                          _vm._v("ที่อยู่รับเอกสาร")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.documentsReceive,
                              expression: "documentsReceive"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", id: "documents-receive" },
                          domProps: { value: _vm.documentsReceive },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.documentsReceive = $event.target.value
                            }
                          }
                        })
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card shadow-sm" }, [
              _c("div", { staticClass: "card-body" }, [
                _c("p", { staticClass: "h5" }, [_vm._v("อาชีพ/สถานที่ทำงาน")]),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("div", { staticClass: "form" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _vm._m(9),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.occupation,
                                expression: "occupation"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: { id: "occupation" },
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.occupation = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              }
                            }
                          },
                          _vm._l(
                            [
                              "รับราชการ",
                              "พนักงานรัฐวิสาหกิจ",
                              "พนักงานบริษัท",
                              "เจ้าของกิจการที่จดทะเบียนพานิชย์",
                              "พ่อบ้าน/แม่บ้าน",
                              "อาชีพอิสระ",
                              "กิจการส่วนตัว",
                              "พนักงานรายวัน/ชั่วคราว"
                            ],
                            function(item) {
                              return _c(
                                "option",
                                { key: item, domProps: { value: item } },
                                [_vm._v(" " + _vm._s(item))]
                              )
                            }
                          ),
                          0
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("div", { staticClass: "form" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _vm._m(10),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.officeName,
                              expression: "officeName"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", id: "office-name" },
                          domProps: { value: _vm.officeName },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.officeName = $event.target.value
                            }
                          }
                        })
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("div", { staticClass: "form" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "office-building" } }, [
                          _vm._v("ชื่อหมู่บ้าน/อาคารชุด")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.officeBuilding,
                              expression: "officeBuilding"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", id: "office-building" },
                          domProps: { value: _vm.officeBuilding },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.officeBuilding = $event.target.value
                            }
                          }
                        })
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("div", { staticClass: "form" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "" } }, [
                          _vm._v("เลขที่ห้องชั้น")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.officeRoomNo,
                              expression: "officeRoomNo"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", id: "" },
                          domProps: { value: _vm.officeRoomNo },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.officeRoomNo = $event.target.value
                            }
                          }
                        })
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("div", { staticClass: "form" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "office-address" } }, [
                          _vm._v("บ้านเลขที่")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.officeAddress,
                              expression: "officeAddress"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", id: "office-address" },
                          domProps: { value: _vm.officeAddress },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.officeAddress = $event.target.value
                            }
                          }
                        })
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("div", { staticClass: "form" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "office-moo" } }, [
                          _vm._v("หมู่")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.officeMoo,
                              expression: "officeMoo"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", id: "office-moo" },
                          domProps: { value: _vm.officeMoo },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.officeMoo = $event.target.value
                            }
                          }
                        })
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("div", { staticClass: "form" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "office-soi" } }, [
                          _vm._v("ซอย")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.officeSoi,
                              expression: "officeSoi"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", id: "office-soi" },
                          domProps: { value: _vm.officeSoi },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.officeSoi = $event.target.value
                            }
                          }
                        })
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("div", { staticClass: "form" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "office-road" } }, [
                          _vm._v("ถนน")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.officeRoad,
                              expression: "officeRoad"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", id: "office-road" },
                          domProps: { value: _vm.officeRoad },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.officeRoad = $event.target.value
                            }
                          }
                        })
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("div", { staticClass: "form" }, [
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _vm._m(11),
                          _vm._v(" "),
                          _c("v-select", {
                            attrs: {
                              options: _vm.officeOptionsAddress,
                              label: "texts",
                              id: "office_address"
                            },
                            on: {
                              search: function(search) {
                                _vm.fetchAddress(search)
                              }
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "option",
                                fn: function(option) {
                                  return [
                                    _c("span", { class: option.texts }),
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(option.texts) +
                                        "\n                                      "
                                    )
                                  ]
                                }
                              }
                            ]),
                            model: {
                              value: _vm.officeTextAddress,
                              callback: function($$v) {
                                _vm.officeTextAddress = $$v
                              },
                              expression: "officeTextAddress"
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("div", { staticClass: "form" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _vm._m(12),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.officePhone,
                              expression: "officePhone"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", id: "office-phone" },
                          domProps: { value: _vm.officePhone },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.officePhone = $event.target.value
                            }
                          }
                        })
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("div", { staticClass: "form" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c(
                          "label",
                          { attrs: { for: "office-business-type" } },
                          [_vm._v("ประเภทธุรกิจ")]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.officeBusinessType,
                              expression: "officeBusinessType"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", id: "office-business-type" },
                          domProps: { value: _vm.officeBusinessType },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.officeBusinessType = $event.target.value
                            }
                          }
                        })
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card shadow-sm" }, [
              _c("div", { staticClass: "card-body" }, [
                _c("p", { staticClass: "h5" }, [_vm._v("รายได้")]),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("div", { staticClass: "form" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _vm._m(13),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.income,
                              expression: "income"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", id: "income" },
                          domProps: { value: _vm.income },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.income = $event.target.value
                            }
                          }
                        })
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("div", { staticClass: "form" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "other-income" } }, [
                          _vm._v("รายได้อื่น (ถ้ามี)")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.otherIncome,
                              expression: "otherIncome"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", id: "other-income" },
                          domProps: { value: _vm.otherIncome },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.otherIncome = $event.target.value
                            }
                          }
                        })
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("div", { staticClass: "form" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "income-source" } }, [
                          _vm._v("แหล่งที่มารายได้")
                        ]),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.incomeSource,
                                expression: "incomeSource"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: { id: "income-source" },
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.incomeSource = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              }
                            }
                          },
                          _vm._l(
                            [
                              "รับจ้าง/เงินเดือน",
                              "ธุรกิจส่วนตัว",
                              "โบนัส",
                              "ค่าคอม",
                              "อื่นๆ"
                            ],
                            function(item) {
                              return _c(
                                "option",
                                { key: item, domProps: { value: item } },
                                [_vm._v(" " + _vm._s(item))]
                              )
                            }
                          ),
                          0
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("div", { staticClass: "form" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "other-income-source" } }, [
                          _vm._v("แหล่งที่มารายได้อื่นๆ")
                        ]),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.otherIncomeSource,
                                expression: "otherIncomeSource"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: { id: "other-income-source" },
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.otherIncomeSource = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              }
                            }
                          },
                          _vm._l(
                            [
                              "รับจ้าง/เงินเดือน",
                              "ธุรกิจส่วนตัว",
                              "โบนัส",
                              "ค่าคอม",
                              "อื่นๆ"
                            ],
                            function(item) {
                              return _c(
                                "option",
                                { key: item, domProps: { value: item } },
                                [_vm._v(" " + _vm._s(item))]
                              )
                            }
                          ),
                          0
                        )
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("div", { staticClass: "form" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _vm._m(14),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.invoiceLocation,
                                expression: "invoiceLocation"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: { id: "invoice-location" },
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.invoiceLocation = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              }
                            }
                          },
                          _vm._l(
                            ["ที่ทำงาน", "ที่อยู่ปัจจุบัน", "อีเมล"],
                            function(item) {
                              return _c(
                                "option",
                                { key: item, domProps: { value: item } },
                                [_vm._v(" " + _vm._s(item))]
                              )
                            }
                          ),
                          0
                        )
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card shadow-sm" }, [
              _c("div", { staticClass: "card-body" }, [
                _c("p", { staticClass: "h5" }, [_vm._v("วงเงินกู้")]),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("div", { staticClass: "form" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "campaign" } }, [
                          _vm._v("*CAMPAIGN")
                        ]),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.campaign,
                                expression: "campaign"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: { id: "campaign" },
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.campaign = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              }
                            }
                          },
                          _vm._l(["Beneat"], function(item) {
                            return _c(
                              "option",
                              { key: item, domProps: { value: item } },
                              [_vm._v(" " + _vm._s(item))]
                            )
                          }),
                          0
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("div", { staticClass: "form" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "loan-amt" } }, [
                          _vm._v("*จำนวนเงินที่ขอกู้ เลือกวงเงิน")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.loanAmt,
                              expression: "loanAmt"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", id: "loan-amt" },
                          domProps: { value: _vm.loanAmt },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.loanAmt = $event.target.value
                            }
                          }
                        })
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("div", { staticClass: "form" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "loan-installment" } }, [
                          _vm._v("*ระยะเวลาผ่อนชำระ (เดือน) เลือกระยะเวลา")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.loanInstallment,
                              expression: "loanInstallment"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", id: "loan-installment" },
                          domProps: { value: _vm.loanInstallment },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.loanInstallment = $event.target.value
                            }
                          }
                        })
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("div", { staticClass: "form" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _vm._m(15),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.accountName,
                              expression: "accountName"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", id: "account-name" },
                          domProps: { value: _vm.accountName },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.accountName = $event.target.value
                            }
                          }
                        })
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("div", { staticClass: "form" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _vm._m(16),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.bankAccountNo,
                              expression: "bankAccountNo"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", id: "bank-account-no" },
                          domProps: { value: _vm.bankAccountNo },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.bankAccountNo = $event.target.value
                            }
                          }
                        })
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card shadow-sm" }, [
              _c("div", { staticClass: "card-body" }, [
                _c("p", { staticClass: "h5" }, [_vm._v("ผู้ค้ำ")]),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("div", { staticClass: "form" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "guarantor-prename" } }, [
                          _vm._v("คำนำหน้าชื่อ (ภาษาไทย)")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.guarantorPrename,
                              expression: "guarantorPrename"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", id: "guarantor-prename" },
                          domProps: { value: _vm.guarantorPrename },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.guarantorPrename = $event.target.value
                            }
                          }
                        })
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("div", { staticClass: "form" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "guarantor-thai-name" } }, [
                          _vm._v("ชื่อ-นามสกุลผู้ค้ำ")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.guarantorThaiName,
                              expression: "guarantorThaiName"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", id: "guarantor-thai-name" },
                          domProps: { value: _vm.guarantorThaiName },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.guarantorThaiName = $event.target.value
                            }
                          }
                        })
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("div", { staticClass: "form" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "guarantor-age" } }, [
                          _vm._v("อายุ")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.guarantorAge,
                              expression: "guarantorAge"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", id: "guarantor-age" },
                          domProps: { value: _vm.guarantorAge },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.guarantorAge = $event.target.value
                            }
                          }
                        })
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("div", { staticClass: "form" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "guarantor-origin" } }, [
                          _vm._v("เชื้อชาติ")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.guarantorOrigin,
                              expression: "guarantorOrigin"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", id: "guarantor-origin" },
                          domProps: { value: _vm.guarantorOrigin },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.guarantorOrigin = $event.target.value
                            }
                          }
                        })
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("div", { staticClass: "form" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c(
                          "label",
                          { attrs: { for: "guarantor-nationality" } },
                          [_vm._v("สัญชาติ")]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.guarantorNationality,
                              expression: "guarantorNationality"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", id: "guarantor-nationality" },
                          domProps: { value: _vm.guarantorNationality },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.guarantorNationality = $event.target.value
                            }
                          }
                        })
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("div", { staticClass: "form" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "guarantor-building" } }, [
                          _vm._v("ชื่อหมู่บ้าน/อาคารชุด")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.guarantorBuilding,
                              expression: "guarantorBuilding"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", id: "guarantor-building" },
                          domProps: { value: _vm.guarantorBuilding },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.guarantorBuilding = $event.target.value
                            }
                          }
                        })
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("div", { staticClass: "form" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "guarantor-room-no" } }, [
                          _vm._v("เลขที่ห้องชั้น")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.guarantorRoomNo,
                              expression: "guarantorRoomNo"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", id: "guarantor-room-no" },
                          domProps: { value: _vm.guarantorRoomNo },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.guarantorRoomNo = $event.target.value
                            }
                          }
                        })
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("div", { staticClass: "form" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "guarantor-address" } }, [
                          _vm._v("บ้านเลขที่")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.guarantorAddress,
                              expression: "guarantorAddress"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", id: "guarantor-address" },
                          domProps: { value: _vm.guarantorAddress },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.guarantorAddress = $event.target.value
                            }
                          }
                        })
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("div", { staticClass: "form" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "guarantor-moo" } }, [
                          _vm._v("หมู่")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.guarantorMoo,
                              expression: "guarantorMoo"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", id: "guarantor-moo" },
                          domProps: { value: _vm.guarantorMoo },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.guarantorMoo = $event.target.value
                            }
                          }
                        })
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("div", { staticClass: "form" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "guarantor-soi" } }, [
                          _vm._v("ซอย")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.guarantorSoi,
                              expression: "guarantorSoi"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", id: "guarantor-soi" },
                          domProps: { value: _vm.guarantorSoi },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.guarantorSoi = $event.target.value
                            }
                          }
                        })
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("div", { staticClass: "form" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "guarantor-road" } }, [
                          _vm._v("ถนน")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.guarantorRoad,
                              expression: "guarantorRoad"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", id: "guarantor-road" },
                          domProps: { value: _vm.guarantorRoad },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.guarantorRoad = $event.target.value
                            }
                          }
                        })
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("div", { staticClass: "form" }, [
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _vm._m(17),
                          _vm._v(" "),
                          _c("v-select", {
                            attrs: {
                              id: "guarantor-text-address",
                              options: _vm.officeOptionsAddress,
                              label: "texts"
                            },
                            on: {
                              search: function(search) {
                                _vm.fetchAddress(search)
                              }
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "option",
                                fn: function(option) {
                                  return [
                                    _c("span", { class: option.texts }),
                                    _vm._v(
                                      "\n                                            " +
                                        _vm._s(option.texts) +
                                        "\n                                          "
                                    )
                                  ]
                                }
                              }
                            ]),
                            model: {
                              value: _vm.guarantorTextAddress,
                              callback: function($$v) {
                                _vm.guarantorTextAddress = $$v
                              },
                              expression: "guarantorTextAddress"
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("div", { staticClass: "form" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "guarantor-idcard" } }, [
                          _vm._v("เลขบัตรประชาชน")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.guarantorIdcard,
                              expression: "guarantorIdcard"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", id: "guarantor-idcard" },
                          domProps: { value: _vm.guarantorIdcard },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.guarantorIdcard = $event.target.value
                            }
                          }
                        })
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "product-code" } }, [
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")]),
      _vm._v("ผลิตภัณฑ์")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "branch-code" } }, [
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")]),
      _vm._v("สาขา")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "partner-ref-no" } }, [
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")]),
      _vm._v("เลขที่อ้างอิง")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "prename-thai" } }, [
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")]),
      _vm._v("คำนำหน้าชื่อ (ไทย) ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "thai-name" } }, [
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")]),
      _vm._v("ชื่อ-นามสกุล ภาษาไทย")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "eng-name" } }, [
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")]),
      _vm._v("ชื่อ-นามสกุล ภาษาอังกฤษ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "nationality" } }, [
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")]),
      _vm._v("สัญชาติ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "idcard" } }, [
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")]),
      _vm._v("เลขที่บัตรประชาชน")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "idcard-expire-date" } }, [
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")]),
      _vm._v("วันหมดอายุบัตรประชาชน")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "occupation" } }, [
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")]),
      _vm._v("อาชีพ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "office-name" } }, [
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")]),
      _vm._v("ชื่อสถานที่ทำงาน")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "office_address" } }, [
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")]),
      _vm._v("ที่อยู่")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "office-phone" } }, [
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")]),
      _vm._v("โทรศัพท์")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "income" } }, [
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")]),
      _vm._v("รายได้/เดือน")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "invoice-location" } }, [
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")]),
      _vm._v("สถานที่ส่งใบแจ้งยอด/ใบเสร็จการชำระเงินกู้ และเอกสารอื่นๆ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "account-name" } }, [
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")]),
      _vm._v("ชื่อบัญชี ดึงมาหน้าส่วนแรกข้อมูลส่วนตัวชื่อ-สกุล")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "bank-account-no" } }, [
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")]),
      _vm._v("เลขที่บัญชี")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "guarantor-text-address" } }, [
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")]),
      _vm._v("ที่อยู่")
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-09497992", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09497992","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nimcap/Components/Form/PersonalDetail.vue
// module id = 2309
// module chunks = 0